import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kiosk-item-info"
// 키오스크 노출 정보(설명/이미지) 저장 모달 전용 컨트롤러.
// 이 모달은 pos_controller.js의 item-editor 컨트롤러 바깥(#modals 프레임)에서 렌더링되므로
// item-editor#updateItem 을 직접 재사용할 수 없다. 저장 후에는 그 메서드와 동일하게
// "편집모드 유지" 플래그를 남기고 새로고침해서, item-editor#connect()가 편집모드(삭제/키오스크
// 등록 버튼 노출)를 모든 카드에 다시 적용하도록 한다.
export default class extends Controller {
  saved() {
    localStorage.setItem("item_editor_edit_mode", "true")
    window.location.reload()
  }
}
